import React from 'react';
import PropTypes from 'prop-types';

import { MAX_REASON_LENGTH, MIN_REASON_LENGTH } from './reason_rules';

// PROD-7828: mandatory operator note for payment-impacting edits, with its own inline error line.
function RequiredReasonTextarea(props) {
  const { value, onChange, name, placeholder, error, errorText, height } = props;
  return (
    <>
      <div style={{ margin: '10px 0' }}>
        <textarea
          value={value}
          name={name}
          onChange={onChange}
          style={{ width: '300px', height }}
          maxLength={MAX_REASON_LENGTH}
          placeholder={placeholder}
        />
      </div>
      {error ? (
        <p style={{ color: 'var(--state-error)' }}>
          * {errorText || `A reason (at least ${MIN_REASON_LENGTH} characters) is required`}
        </p>
      ) : null}
    </>
  );
}

RequiredReasonTextarea.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  name: PropTypes.string,
  placeholder: PropTypes.string,
  error: PropTypes.bool,
  errorText: PropTypes.string,
  height: PropTypes.string
};

RequiredReasonTextarea.defaultProps = {
  value: '',
  name: undefined,
  placeholder: 'Reason (required)',
  error: false,
  errorText: '',
  height: '100px'
};

export default RequiredReasonTextarea;
